(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  let observedZendeskWidget;
  const bindZendeskWidgetEvents = () => {
    if (typeof window.zE !== 'function' || observedZendeskWidget === window.zE) return;

    // PC 的原生 launcher 同时是关闭入口，只在会话窗口打开时解除隐藏。
    // 监听两种产品的官方事件；异步占位函数被替换后补绑，点击前也检查一次。
    for (const namespace of ['messenger:on', 'webWidget:on']) {
      try {
        window.zE(namespace, 'open', () => document.documentElement.setAttribute('data-zendesk-open', ''));
        window.zE(namespace, 'close', () => document.documentElement.removeAttribute('data-zendesk-open'));
      } catch (error) {
        // 当前店铺未使用该产品，保留另一种产品的事件绑定。
      }
    }
    observedZendeskWidget = window.zE;
  };

  (() => {
    // Zendesk 脚本由 layout/theme.liquid 加载，window.zE 存在不代表挂件真的能用——
    // 脚本刚插入时 zE 只是个占位的排队函数，真正的挂件逻辑加载完才会把它替换掉，
    // 这里跟 new-h5 项目 zendesk.client.js 用同一个判断方式：占位函数 toString 很短，
    // 真正实现的 toString 很多。轮询到真正就绪后再摘掉按钮上的呼吸动画。
    const contactTriggers = document.querySelectorAll('[data-zendesk-widget-trigger]');

    bindZendeskWidgetEvents();

    let attempts = 0;
    const maxAttempts = 100; // 100ms * 100 = 10s，超时也摘掉动画，避免一直转
    const readyTimer = setInterval(() => {
      attempts += 1;
      bindZendeskWidgetEvents();
      const ready = typeof window.zE === 'function' && window.zE.toString().length > 40;
      if (ready || attempts >= maxAttempts) {
        contactTriggers.forEach((trigger) => trigger.classList.remove('is-zendesk-loading'));
        clearInterval(readyTimer);
      }
    }, 100);

    // Zendesk 挂件异步加载完才给 body 上 position:fixed 锁滚动,不补 top 导致 scrollY 清零。
    // 我们自己的弹窗锁滚动走 html[scroll-lock](见 base.css),不冲突,可以全程监听。
    let lastY = window.scrollY;
    let locked = false;
    window.addEventListener('scroll', () => { if (!locked) lastY = window.scrollY; }, { passive: true });
    new MutationObserver(() => {
      const nowLocked = document.body.style.position === 'fixed';
      if (nowLocked && !locked) {
        locked = true;
        if (!document.body.style.top) document.body.style.top = `-${lastY}px`;
      } else if (!nowLocked && locked) {
        locked = false;
        document.body.style.top = '';
        window.scrollTo({ top: lastY, left: 0, behavior: 'instant' });
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
  })();

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-yotpo-spotlight-trigger]')) {
      // 点击复用真实的 Yotpo spotlight CTA（该 app block 的点击逻辑由 Yotpo 远程脚本注入，
      // 未登录跳转登录页、已登录弹开抽屉都由它内部处理，这里只是转发一次真实 click）
      const yotpoTrigger = document.querySelector('.yotpo-widget-spotlight-cta__button');
      if (yotpoTrigger) yotpoTrigger.click();
      return;
    }

    if (event.target.closest('[data-zendesk-widget-trigger]')) {
      // Zendesk Web Widget 的脚本由 layout/theme.liquid 加载，全局暴露 window.zE。
      // classic Web Widget 和新版 Messaging 的打开命令不同（'webWidget' vs 'messenger'），
      // 且调用了当前产品不支持的命令会直接抛异常（不是静默忽略），所以分开 try/catch，
      // 保证一个失败不会挡住另一个执行。
      if (typeof window.zE === 'function') {
        bindZendeskWidgetEvents();
        try {
          window.zE('messenger', 'open');
        } catch (error) {
          // 当前店铺不是 Messaging，忽略
        }
        try {
          window.zE('webWidget', 'open');
        } catch (error) {
          // 当前店铺不是 Classic Web Widget，忽略
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
